import React, { useState } from 'react';
import {
  Menu,
  MenuItem,
  Typography,
  Button,
  Box,
  Divider,
  Tooltip,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const timeZoneOptions = [
  { label: "Member's time zone", value: 'IST: Asia - Kolkata' },
  { label: 'My time zone', value: 'IST: Asia - Kolkata' },
  { label: 'Acadecraft Private Limited', value: 'IST: Asia - Kolkata' },
];

export default function TimeZoneDropdown() {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <Box>
      <Tooltip title="IST: Asia - Kolkata" arrow placement='top'>
        <Button
          onClick={handleClick}
          endIcon={<ExpandMoreIcon />}
          variant="outlined"
          sx={{
            background: '#fff',
            borderRadius: '50px',
            color: '#64748B',
            fontSize: '14px',
            textTransform: 'capitalize',
            height: '38px',
            border: '1px solid #E5E8EB',
            '&:hover': {
              background: '#f5f5f5'
            }
          }}
        >
          IST
        </Button>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{ sx: { minWidth: 220, p: 1, borderRadius: '15px' } }}
      >
        {timeZoneOptions.map((item, index) => (
          <MenuItem key={index} onClick={handleClose} disableRipple>
            <Box>
              <Typography variant="body2" color="text.secondary">
                {item.label}
              </Typography>
              <Typography variant="body1">{item.value}</Typography>
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}
